import { __decorate, __metadata, __param } from "tslib";
import { DashboardDataException, DashboardException, isAxiosError } from '@/apis/service/exception';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { HttpServiceHelper } from './utils/HttpServiceHelper';
let DashboardHttpService = class DashboardHttpService extends HttpServiceHelper {
    constructor(i18n, httpClient, errorHandlerService) {
        super(errorHandlerService);
        this.i18n = i18n;
        this.httpClient = httpClient;
        this.errorHandlerService = errorHandlerService;
        this.configErrorHandler();
    }
    // #region 全局错误处理相关
    configErrorHandler() {
        this.errorHandlerService.addHandler(error => {
            if (DashboardDataException.is(error)) {
                const msg = error.data?.data?.error_message || this.i18n.t('loginFail.unknown');
                this._errorDisplayProxy(msg);
                return true;
            }
            if (!DashboardException.is(error)) {
                return false;
            }
            const dashboardError = error.response?.data;
            if (!dashboardError) {
                return false;
            }
            // todo有的错误由前端翻译处理
            this._errorDisplayProxy(dashboardError.error_message);
            return true;
        });
    }
    // #endregion
    request(config) {
        config = {
            ...config,
            params: {
                ...config?.params,
            },
        };
        return this.httpClient(config).then((res) => {
            const data = res.data;
            if (data?.status === false) {
                throw DashboardDataException.mark(res);
            }
            return data;
        }, error => {
            if (!isAxiosError(error)) {
                throw error;
            }
            error = DashboardException.mark(error);
            throw error;
        });
    }
};
DashboardHttpService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.HttpClient)),
    __param(2, inject(Symbols.ErrorHandlerService)),
    __metadata("design:paramtypes", [Object, Object, Object])
], DashboardHttpService);
export { DashboardHttpService };
